import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/client/src/app/(main)/qa/components/qa-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.2.9_@playwright+test@1.62.1_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/client/app-dir/link.js");
